/**
 * extension-signal-broadcast.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { validateAs, validateFor } from "../../validation/decorators";
import { IncomingMessage } from "../general/incoming-message";
import { MessageTag } from "../message-tag";
import { ExtensionPayload } from "./extension-signal-request";

@validateFor(MessageTag.BCST_EXTENSION_SIGNAL)
export class ExtensionSignalBroadcast<P extends ExtensionPayload>
extends IncomingMessage
{
    /** The unique tag for this message type */
    public tag : MessageTag = MessageTag.BCST_EXTENSION_SIGNAL;

    @validateAs("object")
    public payload : P;

    @validateAs("integer")
    public senderId : number;

    @validateAs("string")
    public senderName : string;

    @validateAs("string")
    public senderOrganization : string;
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/collaboration/extension-signal-broadcast.ts